import { Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { useAiAssistantAdminContext } from "./ai-assistant-admin-context";
import { OrbSection } from "./orb-section";
import { StyleSection } from "./style-section";
import { useAssistantStyle } from "./use-assistant-style";

/** Sub menu "Persona": gaya & aturan bicara Jenna dan tampilan orb. */
export function PersonaPage() {
	const { overview, disabled, unavailable } = useAiAssistantAdminContext();
	const style = useAssistantStyle();
	return (
		<>
			{style.error && (
				<Alert color="red" icon={<IconAlertCircle size={16} />}>
					{style.error}
				</Alert>
			)}
			<StyleSection
				style={style.style}
				assistantName={overview.settings.assistantName}
				disabled={disabled || style.loading || style.unavailable}
				unavailable={!unavailable && style.unavailable}
				onSaved={style.apply}
			/>
			<OrbSection
				assistantName={overview.settings.assistantName}
				disabled={disabled}
			/>
		</>
	);
}
